export class PromiseWrapper {
    static delay(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }
    static async delayForever() {
        const biggestPossibleDelay = 2147483647;
        while (true) {
            await this.delay(biggestPossibleDelay);
        }
    }
    get ended() {
        return this.rejected || this.resolved;
    }
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = (t) => {
                this.resolved = true;
                resolve(t);
            };
            this.reject = (err) => {
                this.rejected = true;
                reject(err);
            };
        });
    }
}
export function callbackifyPromise(action, successCallback, errorCallback, logger, token) {
    const fail = (error) => {
        if (logger) {
            logger.error(`[${token}]`, error);
        }
        let msg = error;
        if (error instanceof Error) {
            msg = error.message;
        }
        if (typeof errorCallback === "function") {
            errorCallback(msg);
            return;
        }
        return PromiseWrapper.delay(0)
            .then(() => {
            throw error;
        });
    };
    return PromiseWrapper.delay(0)
        .then(action)
        .then((result) => {
        if (logger) {
            logger.info(`[${token}] successful`);
        }
        if (typeof successCallback === "function") {
            successCallback(result);
        }
        return result;
    })
        .catch((error) => {
        return fail(error);
    });
}
export function nextTickPromise(action) {
    return new Promise((resolve, reject) => {
        process.nextTick(() => {
            try {
                resolve(action());
            }
            catch (e) {
                const error = e instanceof Error ? e : new Error(`${e}`);
                reject(error);
            }
        });
    });
}
//# sourceMappingURL=promise.js.map